/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DispositionSagasDispositionQueryVariables = {
    selectedStation: string;
    dispoStartdate: string;
    dispoEnddate: string;
    additionalStations?: string | null | undefined;
    additionalGroups?: string | null | undefined;
    searchForVehicle?: string | null | undefined;
    searchForBooking?: string | null | undefined;
    filterEquipment?: string | null | undefined;
    filterRegion?: string | null | undefined;
    categoryFilter?: string | null | undefined;
};
export type DispositionSagasDispositionQueryResponse = {
    readonly dispositionData: {
        readonly stations: ReadonlyArray<{
            readonly __typename: string;
            readonly stationId: string | null;
            readonly disponame: string | null;
            readonly street: string | null;
            readonly groupReservations: ReadonlyArray<{
                readonly __typename: string;
                readonly bookingId: string;
                readonly hasVehicle: boolean | null;
                readonly startdate: string | null;
                readonly enddate: string | null;
                readonly plannedEnddate: string | null;
                readonly vehicleGroup: {
                    readonly vehicleGroupId: string;
                    readonly description: string | null;
                } | null;
                readonly plannedVehicleGroup: {
                    readonly vehicleGroupId: string;
                    readonly description: string | null;
                } | null;
                readonly startstation: string | null;
                readonly endstation: string | null;
                readonly plannedEndstation: string | null;
                readonly isDraggable: boolean | null;
                readonly isSearchResult: boolean | null;
                readonly contractColor: string | null;
                readonly frameColor: string | null;
                readonly customer: {
                    readonly customerId: string | null;
                    readonly name1: string | null;
                } | null;
                readonly reservationNumber: string | null;
                readonly pickupDate: string | null;
                readonly deliveryDate: string | null;
                readonly driver1: {
                    readonly firstname: string | null;
                    readonly lastname: string | null;
                } | null;
                readonly vehicle: string | null;
                readonly status: string | null;
                readonly rate: string | null;
                readonly divdata: string | null;
            } | null> | null;
            readonly vehicles: ReadonlyArray<{
                readonly stationArriving: string | null;
                readonly __typename: string;
                readonly vehicleId: string;
                readonly name: string | null;
                readonly licensePlate: string | null;
                readonly mileage: number | null;
                readonly maximumMileage: number | null;
                readonly dispoColor: string | null;
                readonly remark: string | null;
                readonly remarkVehicle: string | null;
                readonly vehicleGroup: {
                    readonly vehicleGroupId: string;
                } | null;
                readonly location: {
                    readonly stationId: string | null;
                } | null;
                readonly equipment: string | null;
                readonly wizStatus: string | null;
                readonly wizTurnbackDate: string | null;
                readonly reservations: ReadonlyArray<{
                    readonly __typename: string;
                    readonly bookingId: string;
                    readonly startdate: string | null;
                    readonly enddate: string | null;
                    readonly plannedEnddate: string | null;
                    readonly isDraggable: boolean | null;
                    readonly vehicle: string | null;
                    readonly startstation: string | null;
                    readonly endstation: string | null;
                    readonly plannedEndstation: string | null;
                    readonly isBilled: boolean | null;
                    readonly vehicleGroup: {
                        readonly vehicleGroupId: string;
                        readonly description: string | null;
                    } | null;
                    readonly contractColor: string | null;
                    readonly frameColor: string | null;
                    readonly hasVehicle: boolean | null;
                    readonly customer: {
                        readonly customerId: string | null;
                        readonly name1: string | null;
                    } | null;
                    readonly reservationNumber: string | null;
                    readonly pickupDate: string | null;
                    readonly deliveryDate: string | null;
                    readonly status: string | null;
                    readonly rate: string | null;
                    readonly divdata: string | null;
                    readonly isSearchResult: boolean | null;
                    readonly delivered: boolean | null;
                    readonly readyForPickup: boolean | null;
                    readonly deliveryPrivate: boolean | null;
                    readonly pickupPrivate: boolean | null;
                    readonly hasInvoice: boolean | null;
                    readonly wasReservation: boolean | null;
                    readonly partialInvoiceDate: string | null;
                    readonly plannedVehicleGroup: {
                        readonly vehicleGroupId: string;
                        readonly description: string | null;
                    } | null;
                    readonly driver1: {
                        readonly firstname: string | null;
                        readonly lastname: string | null;
                    } | null;
                } | null> | null;
                readonly availableUntil: string | null;
                readonly availableFrom: string | null;
            } | null> | null;
        } | null> | null;
    } | null;
};
export type DispositionSagasDispositionQuery = {
    readonly response: DispositionSagasDispositionQueryResponse;
    readonly variables: DispositionSagasDispositionQueryVariables;
};



/*
query DispositionSagasDispositionQuery(
  $selectedStation: String!
  $dispoStartdate: String!
  $dispoEnddate: String!
  $additionalStations: String
  $additionalGroups: String
  $searchForVehicle: String
  $searchForBooking: String
  $filterEquipment: String
  $filterRegion: String
  $categoryFilter: String
) {
  dispositionData(selectedStation: $selectedStation, dispoStartdate: $dispoStartdate, dispoEnddate: $dispoEnddate, additionalStations: $additionalStations, additionalGroups: $additionalGroups, searchForBooking: $searchForBooking, searchForVehicle: $searchForVehicle, filterEquipment: $filterEquipment, filterRegion: $filterRegion, filterCategory: $categoryFilter) {
    stations {
      __typename
      stationId
      disponame
      street
      groupReservations {
        __typename
        bookingId
        hasVehicle
        startdate
        enddate
        plannedEnddate
        vehicleGroup {
          vehicleGroupId
          description
        }
        plannedVehicleGroup {
          vehicleGroupId
          description
        }
        startstation
        endstation
        plannedEndstation
        isDraggable
        isSearchResult
        contractColor
        frameColor
        customer {
          customerId
          name1
        }
        reservationNumber
        pickupDate
        deliveryDate
        driver1 {
          firstname
          lastname
        }
        vehicle
        status
        rate
        divdata
      }
      vehicles {
        stationArriving
        __typename
        vehicleId
        name
        licensePlate
        mileage
        maximumMileage
        dispoColor
        remark
        remarkVehicle
        vehicleGroup {
          vehicleGroupId
        }
        location {
          stationId
        }
        equipment
        wizStatus
        wizTurnbackDate
        reservations {
          __typename
          bookingId
          startdate
          enddate
          plannedEnddate
          isDraggable
          vehicle
          startstation
          endstation
          plannedEndstation
          isBilled
          vehicleGroup {
            vehicleGroupId
            description
          }
          contractColor
          frameColor
          hasVehicle
          customer {
            customerId
            name1
          }
          reservationNumber
          pickupDate
          deliveryDate
          status
          rate
          divdata
          isSearchResult
          delivered
          readyForPickup
          deliveryPrivate
          pickupPrivate
          hasInvoice
          wasReservation
          partialInvoiceDate
          plannedVehicleGroup {
            vehicleGroupId
            description
          }
          driver1 {
            firstname
            lastname
          }
        }
        availableUntil
        availableFrom
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "additionalGroups"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "additionalStations"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryFilter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dispoEnddate"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dispoStartdate"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterEquipment"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterRegion"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchForBooking"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchForVehicle"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectedStation"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stationId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bookingId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVehicle",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startdate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enddate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedEnddate",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vehicleGroupId",
  "storageKey": null
},
v18 = [
  (v17/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "VehicleGroup",
  "kind": "LinkedField",
  "name": "vehicleGroup",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "VehicleGroup",
  "kind": "LinkedField",
  "name": "plannedVehicleGroup",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startstation",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endstation",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedEndstation",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraggable",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSearchResult",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contractColor",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frameColor",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Customer",
  "kind": "LinkedField",
  "name": "customer",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name1",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reservationNumber",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pickupDate",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliveryDate",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Driver",
  "kind": "LinkedField",
  "name": "driver1",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastname",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vehicle",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "divdata",
  "storageKey": null
},
v37 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "additionalGroups",
        "variableName": "additionalGroups"
      },
      {
        "kind": "Variable",
        "name": "additionalStations",
        "variableName": "additionalStations"
      },
      {
        "kind": "Variable",
        "name": "dispoEnddate",
        "variableName": "dispoEnddate"
      },
      {
        "kind": "Variable",
        "name": "dispoStartdate",
        "variableName": "dispoStartdate"
      },
      {
        "kind": "Variable",
        "name": "filterCategory",
        "variableName": "categoryFilter"
      },
      {
        "kind": "Variable",
        "name": "filterEquipment",
        "variableName": "filterEquipment"
      },
      {
        "kind": "Variable",
        "name": "filterRegion",
        "variableName": "filterRegion"
      },
      {
        "kind": "Variable",
        "name": "searchForBooking",
        "variableName": "searchForBooking"
      },
      {
        "kind": "Variable",
        "name": "searchForVehicle",
        "variableName": "searchForVehicle"
      },
      {
        "kind": "Variable",
        "name": "selectedStation",
        "variableName": "selectedStation"
      }
    ],
    "concreteType": "DispositionData",
    "kind": "LinkedField",
    "name": "dispositionData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Station",
        "kind": "LinkedField",
        "name": "stations",
        "plural": true,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "disponame",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "street",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SimpleBooking",
            "kind": "LinkedField",
            "name": "groupReservations",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SimpleVehicle",
            "kind": "LinkedField",
            "name": "vehicles",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stationArriving",
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vehicleId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "licensePlate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mileage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maximumMileage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dispoColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remark",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remarkVehicle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VehicleGroup",
                "kind": "LinkedField",
                "name": "vehicleGroup",
                "plural": false,
                "selections": [
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Station",
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "equipment",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wizStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wizTurnbackDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SimpleBooking",
                "kind": "LinkedField",
                "name": "reservations",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v12/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v24/*: any*/),
                  (v33/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isBilled",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v13/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "delivered",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "readyForPickup",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliveryPrivate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pickupPrivate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasInvoice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wasReservation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "partialInvoiceDate",
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v32/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availableUntil",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availableFrom",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DispositionSagasDispositionQuery",
    "selections": (v37/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "DispositionSagasDispositionQuery",
    "selections": (v37/*: any*/)
  },
  "params": {
    "cacheID": "f608deb71f8f1481c82116c9247eabe7",
    "id": null,
    "metadata": {},
    "name": "DispositionSagasDispositionQuery",
    "operationKind": "query",
    "text": "query DispositionSagasDispositionQuery(\n  $selectedStation: String!\n  $dispoStartdate: String!\n  $dispoEnddate: String!\n  $additionalStations: String\n  $additionalGroups: String\n  $searchForVehicle: String\n  $searchForBooking: String\n  $filterEquipment: String\n  $filterRegion: String\n  $categoryFilter: String\n) {\n  dispositionData(selectedStation: $selectedStation, dispoStartdate: $dispoStartdate, dispoEnddate: $dispoEnddate, additionalStations: $additionalStations, additionalGroups: $additionalGroups, searchForBooking: $searchForBooking, searchForVehicle: $searchForVehicle, filterEquipment: $filterEquipment, filterRegion: $filterRegion, filterCategory: $categoryFilter) {\n    stations {\n      __typename\n      stationId\n      disponame\n      street\n      groupReservations {\n        __typename\n        bookingId\n        hasVehicle\n        startdate\n        enddate\n        plannedEnddate\n        vehicleGroup {\n          vehicleGroupId\n          description\n        }\n        plannedVehicleGroup {\n          vehicleGroupId\n          description\n        }\n        startstation\n        endstation\n        plannedEndstation\n        isDraggable\n        isSearchResult\n        contractColor\n        frameColor\n        customer {\n          customerId\n          name1\n        }\n        reservationNumber\n        pickupDate\n        deliveryDate\n        driver1 {\n          firstname\n          lastname\n        }\n        vehicle\n        status\n        rate\n        divdata\n      }\n      vehicles {\n        stationArriving\n        __typename\n        vehicleId\n        name\n        licensePlate\n        mileage\n        maximumMileage\n        dispoColor\n        remark\n        remarkVehicle\n        vehicleGroup {\n          vehicleGroupId\n        }\n        location {\n          stationId\n        }\n        equipment\n        wizStatus\n        wizTurnbackDate\n        reservations {\n          __typename\n          bookingId\n          startdate\n          enddate\n          plannedEnddate\n          isDraggable\n          vehicle\n          startstation\n          endstation\n          plannedEndstation\n          isBilled\n          vehicleGroup {\n            vehicleGroupId\n            description\n          }\n          contractColor\n          frameColor\n          hasVehicle\n          customer {\n            customerId\n            name1\n          }\n          reservationNumber\n          pickupDate\n          deliveryDate\n          status\n          rate\n          divdata\n          isSearchResult\n          delivered\n          readyForPickup\n          deliveryPrivate\n          pickupPrivate\n          hasInvoice\n          wasReservation\n          partialInvoiceDate\n          plannedVehicleGroup {\n            vehicleGroupId\n            description\n          }\n          driver1 {\n            firstname\n            lastname\n          }\n        }\n        availableUntil\n        availableFrom\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b3fb8ce6543bed69f4e24f52c1d57dde';
export default node;
